// extracted by mini-css-extract-plugin
module.exports = {"section_title":"SectionTitle_section_title__5jpiQ","content":"SectionTitle_content__ON4jT"};